export default "__VITE_ASSET__Bv7Rhu5x__"